const getColor = (value) => {
  if (Number(value) >= 100) {
    return {
      background: 'rgba(68, 193, 152, 1)',
      color: '#fff'
    }
  } else if (Number(value) >= 75) {
    return {
      background: 'rgba(68, 193, 152, 1)',
      color: '#fff'
    }
  } else if (Number(value) >= 60) {
    return {
      background: 'rgba(187, 247, 208, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 45) {
    return {
      background: 'rgba(220, 252, 231, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 35) {
    return {
      background: 'rgba(254, 240, 138, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 25) {
    return {
      background: 'rgba(254, 249, 195, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 10) {
    return {
      background: 'rgba(254, 252, 232, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.001) {
    return {
      background: '#FFFBEB',
      color: '#000'
    }
  } else
    return {
      background: '#fff',
      color: '#000'
    }
}

export const drawerColumn = [
  {
    title: '激活时间',
    width: 120,
    key: 'statTime'
  },
  {
    title: '消耗',
    width: 70,
    key: 'cost',
    render: (h, params) => {
      console.log(params)

      return (
        <div style="background: rgba(187, 247, 208, 1);background-size:70%">
          {params.row.cost}
        </div>
      )
    }
  },
  {
    title: '时段累计ROI',
    width: 130,
    key: 'hourROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hourROINew)
          }}
        >
          {params.row.hourROINew
            ? Number(params.row.hourROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '时段累计ROI',
    width: 130,
    key: 'hourROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hourROIAll)
          }}
        >
          {params.row.hourROIAll
            ? Number(params.row.hourROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '激活成本/激活人数',
    width: 140,
    key: 'userCountPercentNew',
    flag: 1
  },
  {
    title: '激活成本/激活人数',
    width: 140,
    key: 'userCountPercentAll',
    flag: 2
  },
  {
    title: '付费成本/付费人数',
    width: 140,
    key: 'payUserCountPercentNew',
    flag: 1
  },
  {
    title: '付费成本/付费人数',
    width: 140,
    key: 'payUserCountPercentAll',
    flag: 2
  },
  {
    title: '第1hROI',
    width: 90,
    key: 'hour0ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour0ROINew)
          }}
        >
          {params.row.hour0ROINew
            ? Number(params.row.hour0ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第1hROI',
    width: 90,
    key: 'hour0ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour0ROIAll)
          }}
        >
          {params.row.hour0ROIAll
            ? Number(params.row.hour0ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第2hROI',
    width: 90,
    key: 'hour1ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour1ROINew)
          }}
        >
          {params.row.hour1ROINew
            ? Number(params.row.hour1ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第2hROI',
    width: 90,
    key: 'hour1ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour1ROIAll)
          }}
        >
          {params.row.hour1ROIAll
            ? Number(params.row.hour1ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第3hROI',
    width: 90,
    key: 'hour2ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour2ROINew)
          }}
        >
          {params.row.hour2ROINew
            ? Number(params.row.hour2ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第3hROI',
    width: 90,
    key: 'hour2ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour2ROIAll)
          }}
        >
          {params.row.hour2ROIAll
            ? Number(params.row.hour2ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第4hROI',
    width: 90,
    key: 'hour3ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour3ROINew)
          }}
        >
          {params.row.hour3ROINew
            ? Number(params.row.hour3ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第4hROI',
    width: 90,
    key: 'hour3ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour3ROIAll)
          }}
        >
          {params.row.hour3ROIAll
            ? Number(params.row.hour3ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第5hROI',
    width: 90,
    key: 'hour4ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour4ROINew)
          }}
        >
          {params.row.hour4ROINew
            ? Number(params.row.hour4ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第5hROI',
    width: 90,
    key: 'hour4ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour4ROIAll)
          }}
        >
          {params.row.hour4ROIAll
            ? Number(params.row.hour4ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第6hROI',
    width: 90,
    key: 'hour5ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour5ROINew)
          }}
        >
          {params.row.hour5ROINew
            ? Number(params.row.hour5ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第6hROI',
    width: 90,
    key: 'hour5ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour5ROIAll)
          }}
        >
          {params.row.hour5ROIAll
            ? Number(params.row.hour5ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第7hROI',
    width: 90,
    key: 'hour6ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour6ROINew)
          }}
        >
          {params.row.hour6ROINew
            ? Number(params.row.hour6ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第7hROI',
    width: 90,
    key: 'hour6ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour6ROIAll)
          }}
        >
          {params.row.hour6ROIAll
            ? Number(params.row.hour6ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第8hROI',
    width: 90,
    key: 'hour7ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour7ROINew)
          }}
        >
          {params.row.hour7ROINew
            ? Number(params.row.hour7ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第8hROI',
    width: 90,
    key: 'hour7ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour7ROIAll)
          }}
        >
          {params.row.hour7ROIAll
            ? Number(params.row.hour7ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第9hROI',
    width: 90,
    key: 'hour8ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour8ROINew)
          }}
        >
          {params.row.hour8ROINew
            ? Number(params.row.hour8ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第9hROI',
    width: 90,
    key: 'hour8ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour8ROIAll)
          }}
        >
          {params.row.hour8ROIAll
            ? Number(params.row.hour8ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第10hROI',
    width: 100,
    key: 'hour9ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour9ROINew)
          }}
        >
          {params.row.hour9ROINew
            ? Number(params.row.hour9ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第10hROI',
    width: 100,
    key: 'hour9ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour9ROIAll)
          }}
        >
          {params.row.hour9ROIAll
            ? Number(params.row.hour9ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第11hROI',
    width: 100,
    key: 'hour10ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour10ROINew)
          }}
        >
          {params.row.hour10ROINew
            ? Number(params.row.hour10ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第11hROI',
    width: 100,
    key: 'hour10ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour10ROIAll)
          }}
        >
          {params.row.hour10ROIAll
            ? Number(params.row.hour10ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第12hROI',
    width: 100,
    key: 'hour11ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour11ROINew)
          }}
        >
          {params.row.hour11ROINew
            ? Number(params.row.hour11ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第12hROI',
    width: 100,
    key: 'hour11ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour11ROIAll)
          }}
        >
          {params.row.hour11ROIAll
            ? Number(params.row.hour11ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第13hROI',
    width: 100,
    key: 'hour12ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour12ROINew)
          }}
        >
          {params.row.hour12ROINew
            ? Number(params.row.hour12ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第13hROI',
    width: 100,
    key: 'hour12ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour12ROIAll)
          }}
        >
          {params.row.hour12ROIAll
            ? Number(params.row.hour12ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第14hROI',
    width: 100,
    key: 'hour13ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour13ROINew)
          }}
        >
          {params.row.hour13ROINew
            ? Number(params.row.hour13ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第14hROI',
    width: 100,
    key: 'hour13ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour13ROIAll)
          }}
        >
          {params.row.hour13ROIAll
            ? Number(params.row.hour13ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第15hROI',
    width: 100,
    key: 'hour14ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour14ROINew)
          }}
        >
          {params.row.hour14ROINew
            ? Number(params.row.hour14ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第15hROI',
    width: 100,
    key: 'hour14ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour14ROIAll)
          }}
        >
          {params.row.hour14ROIAll
            ? Number(params.row.hour14ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第16hROI',
    width: 100,
    key: 'hour15ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour15ROINew)
          }}
        >
          {params.row.hour15ROINew
            ? Number(params.row.hour15ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第16hROI',
    width: 100,
    key: 'hour15ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour15ROIAll)
          }}
        >
          {params.row.hour15ROIAll
            ? Number(params.row.hour15ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第17hROI',
    width: 100,
    key: 'hour16ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour16ROINew)
          }}
        >
          {params.row.hour16ROINew
            ? Number(params.row.hour16ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第17hROI',
    width: 100,
    key: 'hour16ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour16ROIAll)
          }}
        >
          {params.row.hour16ROIAll
            ? Number(params.row.hour16ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第18hROI',
    width: 100,
    key: 'hour17ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour17ROINew)
          }}
        >
          {params.row.hour17ROINew
            ? Number(params.row.hour17ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第18hROI',
    width: 100,
    key: 'hour17ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour17ROIAll)
          }}
        >
          {params.row.hour17ROIAll
            ? Number(params.row.hour17ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第19hROI',
    width: 100,
    key: 'hour18ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour18ROINew)
          }}
        >
          {params.row.hour18ROINew
            ? Number(params.row.hour18ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第19hROI',
    width: 100,
    key: 'hour18ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour18ROIAll)
          }}
        >
          {params.row.hour18ROIAll
            ? Number(params.row.hour18ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第20hROI',
    width: 100,
    key: 'hour19ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour19ROINew)
          }}
        >
          {params.row.hour19ROINew
            ? Number(params.row.hour19ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第20hROI',
    width: 100,
    key: 'hour19ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour19ROIAll)
          }}
        >
          {params.row.hour19ROIAll
            ? Number(params.row.hour19ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第21hROI',
    width: 100,
    key: 'hour20ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour20ROINew)
          }}
        >
          {params.row.hour20ROINew
            ? Number(params.row.hour20ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第21hROI',
    width: 100,
    key: 'hour20ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour20ROIAll)
          }}
        >
          {params.row.hour20ROIAll
            ? Number(params.row.hour20ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第22hROI',
    width: 100,
    key: 'hour21ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour21ROINew)
          }}
        >
          {params.row.hour21ROINew
            ? Number(params.row.hour21ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第22hROI',
    width: 100,
    key: 'hour21ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour21ROIAll)
          }}
        >
          {params.row.hour21ROIAll
            ? Number(params.row.hour21ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第23hROI',
    width: 100,
    key: 'hour22ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour22ROINew)
          }}
        >
          {params.row.hour22ROINew
            ? Number(params.row.hour22ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第23hROI',
    width: 100,
    key: 'hour22ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour22ROIAll)
          }}
        >
          {params.row.hour22ROIAll
            ? Number(params.row.hour22ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第24hROI',
    width: 100,
    key: 'hour23ROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour23ROINew)
          }}
        >
          {params.row.hour23ROINew
            ? Number(params.row.hour23ROINew).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '第24hROI',
    width: 100,
    key: 'hour23ROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.hour23ROIAll)
          }}
        >
          {params.row.hour23ROIAll
            ? Number(params.row.hour23ROIAll).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  }
]

export const countryColumn = [
  {
    title: '国家',
    width: 120,
    fixed: 'left',
    key: 'countryName'
  },
  {
    title: '消耗',
    width: 100,
    fixed: 'left',
    key: 'cost',
    render: (h, params) => {
      return (
        <div style="background: rgba(187, 247, 208, 1);background-size:70%">
          {params.row.cost}
        </div>
      )
    }
  },
  {
    title: '消耗占比',
    width: 120,
    fixed: 'left',
    key: 'costPercent',
    render: (h, params) => {
      return (
        <div>
          {params.row.costPercent
            ? (Number(params.row.costPercent)*100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日ROI',
    
    fixed: 'left',
    width: 100,
    index: '22',
    needCalc: true,
    key: 'firstROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.firstROINew)
          }}
        >
          {params.row.firstROINew
            ? (Number(params.row.firstROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日ROI',
    
    width: 100,
    fixed: 'left',
    index: '23',
    needCalc: true,
    key: 'firstROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.firstROIAll)
          }}
        >
          {params.row.firstROIAll
            ? (Number(params.row.firstROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '新用户数',
    
    width: 120,
    flag: 1,
    index: '3',
    notFixed: true,
    key: 'userCountNew'
  },
  {
    title: '染色用户数',
    
    width: 120,
    notFixed: true,
    flag: 2,
    index: '4',
    key: 'userCountAll'
  },
  {
    title: '新用户激活成本',
    
    width: 140,
    index: '8',
    key: 'activationCostNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.activationCostNew
            ? Number(params.row.activationCostNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '染色用户激活成本',
    
    width: 160,
    index: '9',
    key: 'activationCostAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.activationCostAll
            ? Number(params.row.activationCostAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费用户数',
    
    width: 140,
    notFixed: true,
    index: '44',
    key: 'paySuccessUserCountNew',
    flag: 1
  },
  {
    title: '首日付费用户数',
    
    width: 150,
    notFixed: true,
    index: '45',
    key: 'paySuccessUserCountAll',
    flag: 2
  },
  {
    title: '首日付费用户成本',
    
    width: 160,
    index: '56',
    key: 'firstDayPayCostNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayPayCostNew
            ? Number(params.row.firstDayPayCostNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费用户成本',
    
    width: 160,
    index: '57',
    key: 'firstDayPayCostAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayPayCostAll
            ? Number(params.row.firstDayPayCostAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日arppu',
    
    width: 120,
    index: '64',
    key: 'firstDayArppuNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayArppuNew
            ? Number(params.row.firstDayArppuNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日arppu',
    
    width: 120,
    index: '65',
    key: 'firstDayArppuAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayArppuAll
            ? Number(params.row.firstDayArppuAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '新用户占比',
    
    needCalc: true,
    width: 120,
    index: '6',
    key: 'userCountPrecentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.userCountPrecentNew
            ? (Number(params.row.userCountPrecentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '染色用户占比',
    
    needCalc: true,
    width: 130,
    index: '7',
    key: 'userCountPrecentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.userCountPrecentAll
            ? (Number(params.row.userCountPrecentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日ROI',
    
    width: 100,
    index: '24',
    needCalc: true,
    key: 'thirdROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirdROINew)
          }}
        >
          {params.row.thirdROINew
            ? (Number(params.row.thirdROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日ROI',
    
    needCalc: true,
    width: 100,
    index: '25',
    key: 'thirdROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirdROIAll)
          }}
        >
          {params.row.thirdROIAll
            ? (Number(params.row.thirdROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日ROI',
    
    needCalc: true,
    width: 100,
    index: '26',
    key: 'eighthROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.eighthROINew)
          }}
        >
          {params.row.eighthROINew
            ? (Number(params.row.eighthROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日ROI',
    
    width: 100,
    needCalc: true,
    index: '27',
    key: 'eighthROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.eighthROIAll)
          }}
        >
          {params.row.eighthROIAll
            ? (Number(params.row.eighthROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日ROI',
    
    width: 110,
    index: '30',
    needCalc: true,
    key: 'thirtyROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirtyROINew)
          }}
        >
          {params.row.thirtyROINew
            ? (Number(params.row.thirtyROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日ROI',
    
    width: 110,
    index: '31',
    key: 'thirtyROIAll',
    needCalc: true,
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirtyROIAll)
          }}
        >
          {params.row.thirtyROIAll
            ? (Number(params.row.thirtyROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日累充/首日充值',
    
    width: 150,
    index: '34',
    key: 'threeTimesGrowthNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.threeTimesGrowthNew
            ? Number(params.row.threeTimesGrowthNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日累充/首日充值',
    
    width: 250,
    index: '35',
    key: 'threeTimesGrowthAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.threeTimesGrowthAll
            ? Number(params.row.threeTimesGrowthAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日累充/首日充值',
    
    width: 150,
    index: '36',
    key: 'eighthTimesGrowthNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthTimesGrowthNew
            ? Number(params.row.eighthTimesGrowthNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日累充/首日充值',
    
    width: 150,
    index: '37',
    key: 'eighthTimesGrowthAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthTimesGrowthAll
            ? Number(params.row.eighthTimesGrowthAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日累充/首日充值',
    
    width: 160,
    index: '40',
    key: 'thirtyTimesGrowthNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyTimesGrowthNew
            ? Number(params.row.thirtyTimesGrowthNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日累充/首日充值',
    
    width: 160,
    index: '41',
    key: 'thirtyTimesGrowthAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyTimesGrowthAll
            ? Number(params.row.thirtyTimesGrowthAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '累计付费用户成本',
    
    width: 160,
    index: '56',
    key: 'payCostNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.payCostNew
            ? Number(params.row.payCostNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '累计付费用户成本',
    
    width: 160,
    index: '56',
    key: 'payCostAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.payCostAll
            ? Number(params.row.payCostAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日累计付费用户数',
    
    notFixed: true,
    width: 170,
    index: '46',
    key: 'sixtyDaysPaySuccessUserCountNew',
    flag: 1
  },
  {
    title: '60日累计付费用户数',
    
    width: 170,
    notFixed: true,
    index: '47',
    key: 'sixtyDaysPaySuccessUserCountAll',
    flag: 2
  },
  {
    title: '累计arppu',
    
    width: 120,
    index: '64',
    key: 'arppuNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.arppuNew
            ? Number(params.row.arppuNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '累计arppu',
    
    width: 120,
    index: '64',
    key: 'arppuAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.arppuAll
            ? Number(params.row.arppuAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
]
